import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/header';
import Sidebar from '../components/sidebar';

export default function ApproveBookLayout() {
  const [showSidebar, setShowSidebar] = useState(true);

  const contentClassName = ['application_content'];
  if (showSidebar) {
    contentClassName.push('application-content--sidebar-shown');
  } else {
    contentClassName.push('padding-left-0');
  }

  return (
    <>
      <Sidebar isShow={showSidebar} onClose={() => setShowSidebar(false)} />
      <Header showSidebar={showSidebar} onOpenSidebar={() => setShowSidebar(true)} />
      <div className={'application_content__wrapper'}>
        <div className={contentClassName.join(' ')}
             style={{
               display: 'flex',
               flexDirection: 'column'
             }}>
          <Outlet />
        </div>
      </div>
    </>
  );
}
